"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ref = void 0;
const ref = (effect) => ({
    current: null,
    effect,
});
exports.ref = ref;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVmLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3BhY2thZ2VzL2NvcmUvcmVmLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVPLE1BQU0sR0FBRyxHQUFHLENBQ2pCLE1BQXVDLEVBQ3JCLEVBQUUsQ0FBQyxDQUFDO0lBQ3RCLE9BQU8sRUFBRSxJQUFJO0lBQ2IsTUFBTTtDQUNQLENBQUMsQ0FBQztBQUxVLFFBQUEsR0FBRyxPQUtiIn0=